var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar"
  }, [_c('AmazonTransparencyIcon', {
    staticClass: "transparency-logo"
  }), _c('div', {
    staticClass: "sidebar-btn d-flex align-center",
    class: {
      active: _vm.selected === 'products'
    },
    on: {
      "click": function ($event) {
        return _vm.goToTab('products');
      }
    }
  }, [_c('ProductsIcon', {
    staticClass: "mr-3",
    attrs: {
      "color": _vm.selected === 'products' ? '#00a1ec' : 'black'
    }
  }), _c('span', {
    staticClass: "sidebar-text text-capitalize"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_products')))])], 1), _c('div', {
    staticClass: "sidebar-btn d-flex align-center",
    class: {
      active: _vm.selected === 'transactions'
    },
    on: {
      "click": function ($event) {
        return _vm.goToTab('transactions');
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "size": "24",
      "color": _vm.selected === 'transactions' ? 'primary' : 'black'
    }
  }, [_vm._v("mdi-swap-vertical-bold")]), _c('span', {
    staticClass: "sidebar-text text-capitalize"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_tbya_transactions')))])], 1), _vm.isAdmin ? _c('div', {
    staticClass: "sidebar-btn d-flex align-center",
    class: {
      active: _vm.selected === 'config'
    },
    on: {
      "click": function ($event) {
        return _vm.goToTab('config');
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "size": "24",
      "color": _vm.selected === 'config' ? 'primary' : 'black'
    }
  }, [_vm._v("mdi-security")]), _c('span', {
    staticClass: "sidebar-text text-capitalize"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_config')))])], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }